<script lang="ts">
  import { Total } from "../../../../utils/Constant/Constant";
  import {getCartTotal} from "../../../../Data/Ecommerce/Cartdata"
  import {cart} from "../../../../store"
  let setCart:any
  cart.subscribe((value)=>{
    setCart = value
  })
</script>

{#each setCart as selectItem}
  {#if selectItem.name}
    <tr>
      <td>{selectItem.name}</td>
      <td>{selectItem.qty}</td>
      <td>$ {selectItem.price}</td>
      <td>$ {selectItem.price * selectItem.qty}</td>
    </tr>
  {/if}
{/each}
<tr>
  <td/>
  <td/>
  <td class="Rate">
    <h6 class="mb-0 p-2">{Total}</h6>
  </td>
  <td class="payment">
    <h6 class="mb-0 p-2">$ {getCartTotal(setCart)}</h6>
  </td>
</tr>
